import React from "react"
import { useParams } from "react-router-dom"
import { EDIT } from "../../include/constant"
import NavigationForm from "../common/NavigationForm"
import SuperAdminHeader from "./Header"

const SuperAdminEditNavigation = ({ from }) => {
    const { id } = useParams()

    return <SuperAdminHeader >
        <div className="fixed-top-bar">
            <NavigationForm
                id={id}
                title={"Edit " + from}
                type={EDIT}
                from={from}
            />
        </div>
    </SuperAdminHeader>
}

export default SuperAdminEditNavigation